import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<UserStreamItem @item={{@post}} />",{ moduleName: "discourse/components/pending-post.hbs" })